import React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { MdSearch } from "react-icons/md";

/**
 * 空狀態 — 對應 DESIGN 稿 L809（工項卡片區）與各頁的簡易空狀態文案。
 * variant "card" 帶放大鏡圖示；"plain" 只有文字。
 */
function Empty({ title, hint, variant, pad }) {
  if (variant === "plain") {
    return (
      <Typography color="text.secondary" sx={{ p: pad, textAlign: "center", fontWeight: 600 }}>
        {title}
      </Typography>
    );
  }
  return (
    <Box sx={{ p: pad, textAlign: "center" }}>
      <Avatar
        variant="rounded"
        sx={{ width: 60, height: 60, mx: "auto", mb: 2, bgcolor: "action.hover", color: "text.disabled", fontSize: 28 }}
      >
        <MdSearch />
      </Avatar>
      <Typography variant="h3" component="div" color="text.primary">
        {title}
      </Typography>
      {hint && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {hint}
        </Typography>
      )}
    </Box>
  );
}

Empty.propTypes = {
  title: PropTypes.string,
  hint: PropTypes.string,
  variant: PropTypes.oneOf(["card", "plain"]),
  pad: PropTypes.string,
};

Empty.defaultProps = {
  title: "尚無資料",
  hint: "",
  variant: "card",
  pad: "56px 20px",
};

export default Empty;
